import loader from '../core/loader'
import { ajax } from '../core/ajax'
const _alipayMpSDK = 'https://appx/web-view.min.js'

function initAlipayMp (cb) {
  checkInited(cb)
  loader.sdkReady('alipayMp', _alipayMpSDK, sdk => {
    if (sdk.constructor === Error) {
      cb(sdk) // 异常也抛给前端
    } else {
      requestJSSDKAPI((status, res) => {
        if (status === 'success') {
          const alipay = global.my

          alipay.ready(() => {
            cb(global.my)
            global.__alipayMpReady__ = true
          })

          alipay.error((res) => {
            cb(res)
            global.__alipayMpReady__ = false
          })
        } else {
          cb(res) // 失败回调给前端
        }
      })
    }
  })
}

function checkInited (cb) {
  if (global.__alipayMpReady__) {
    // 进入这个逻辑说明其它的sdk正在初始化微信,那么需要等待初始化完毕
    waitForAlipayReady(cb)
    return
  }
  global.__alipayMpReady__ = true
}

function waitForAlipayReady (cb) {
  function check () {
    if (global.__alipayMpReady__) {
      cb(global.my)
      return
    }
    setTimeout(check, 100)
  }

  check()
}

function requestJSSDKAPI (callback) {
  const { url, method } = getSignApi()
  ajax({
    url,
    method,
    dataType: 'json',
    needEncrypt: true,
    data: {
      url: global.location.href.replace(/#.*/, '')
    },
    success (res) {
      callback('success', res)
    },
    error (status, statusText) {
      callback('failed', statusText)
    }
  })
}

function getSignApi () {
  // 宇宙大号
  return {
    url: '//common.diditaxi.com.cn/general/webEntry/jsapiticket',
    method: 'post'
  }
}

export function alipayMpReady (cb) {
  initAlipayMp(cb)
}
